module.exports = __webpack_public_path__ + "img/LU.97e411b3.svg";